import React, { forwardRef, Ref } from 'react';
import { SimpleIconProps } from '../icon.types';
import Icon from './Icon';

const svg = `<svg viewBox="0 0 24 24" fill="currentColor">
  <path d="M7.07175 14.2033V20.0657C7.07175 20.385 6.96196 20.6544 6.7424 20.8739C6.52283 21.0935 6.25345 21.2033 5.93425 21.2033C5.61503 21.2033 5.34564 21.0935 5.12607 20.8739C4.90651 20.6544 4.79672 20.385 4.79672 20.0657V4.93425C4.79672 4.61503 4.90651 4.34564 5.12607 4.12607C5.34564 3.90651 5.61503 3.79672 5.93425 3.79672H13.2288C13.498 3.79672 13.7362 3.88269 13.9435 4.05462C14.1507 4.22654 14.2833 4.44511 14.3413 4.71032L14.5674 5.79672H19.0657C19.385 5.79672 19.6544 5.90651 19.8739 6.12607C20.0935 6.34564 20.2033 6.61503 20.2033 6.93425V15.0657C20.2033 15.385 20.0935 15.6544 19.8739 15.8739C19.6544 16.0935 19.385 16.2033 19.0657 16.2033H13.7712C13.502 16.2033 13.2638 16.1173 13.0565 15.9454C12.8493 15.7735 12.7167 15.5549 12.6587 15.2897L12.4326 14.2033H7.07175ZM14.7157 13.9282H17.9282V8.07175H13.6228C13.3536 8.07175 13.1154 7.98578 12.9081 7.81385C12.7009 7.64193 12.5683 7.42336 12.5103 7.15815L12.2842 6.07175H7.07175V11.9282H13.3772C13.6464 11.9282 13.8846 12.0142 14.0918 12.1861C14.2991 12.3581 14.4317 12.5766 14.4897 12.8418L14.7157 13.9282Z"/>
</svg>`;

const Flag = forwardRef(
  (props: SimpleIconProps, ref: Ref<SVGSVGElement> | undefined) => (
    <Icon ref={ref} name='flag' svg={svg} {...props} />
  )
);

Flag.displayName = 'FlagIcon';

export default Flag;
